import { Route, Routes } from "react-router-dom"

import { AvisoLegalPage } from "@/features/legal/pages/aviso-legal-page"
import { CarritoPage } from "@/features/cart"
import { ColorShowcase } from "../components/ColorShowcase"
import { ContactPage } from "@/features/contact"
import { DerechosReservadosPage } from "@/features/legal/pages/derechos-reservados-page"
import { HomePage } from "@/features/home"
import { NosotrosPage } from "@/features/about/pages/nosotros-page"
import { PoliticaCookiesPage } from "@/features/legal/pages/politica-cookies-page"
import { PoliticaPrivacidadPage } from "@/features/legal/pages/politica-privacidad-page"
import { ServiciosPage } from "@/features/services"
import { SobreNosotrosPage } from "@/features/about/pages/sobre-nosotros-page"
import { TerminosCondicionesPage } from "@/features/legal/pages/terminos-condiciones-page"
import { VideosPage } from "@/features/videos"
import { BlogPage } from "@/features/blog/page"
import { BlogPostPage } from "@/features/blog/[slug]/page"
import  RecursosPage  from "@/lib/RecursosPage"
export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/servicios" element={<ServiciosPage />} />
      <Route path="/nosotros" element={<NosotrosPage />} />
      <Route path="/sobre-nosotros" element={<SobreNosotrosPage />} />
      <Route path="/videos" element={<VideosPage />} />
      <Route path="/contacto" element={<ContactPage />} />
      <Route path="/carrito" element={<CarritoPage />} />
      <Route path="/colores" element={<ColorShowcase />} />
      <Route path="/politica-privacidad" element={<PoliticaPrivacidadPage />} />
      <Route path="/politica-cookies" element={<PoliticaCookiesPage />} />
      <Route path="/aviso-legal" element={<AvisoLegalPage />} />
      <Route path="/terminos-condiciones" element={<TerminosCondicionesPage />} />
      <Route path="/derechos-reservados" element={<DerechosReservadosPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/recursos" element={<RecursosPage />} />
    </Routes>
  )
}
